// extracted by mini-css-extract-plugin
export var container = "_ev-1";
export var editor = "_ev-2";
export var resizable = "_ev-3";
export var wrapper = "_ev-0";